import { usePayment } from '../context/PaymentContext';
import { PaymentMethod } from '../services/paymentService';

interface UsePaymentMethodsReturn {
    paymentMethods: PaymentMethod[];
    loading: boolean;
    error: string | null;
    stripeInitialized: boolean;
    refreshPaymentMethods: () => Promise<void>;
    addPaymentMethod: (paymentMethodData: any, setAsDefault?: boolean) => Promise<boolean>;
    deletePaymentMethod: (paymentMethodId: string) => Promise<boolean>;
    setDefaultPaymentMethod: (paymentMethodId: string) => Promise<boolean>;
    getDefaultPaymentMethod: () => PaymentMethod | null;
    clearError: () => void;
}

export const usePaymentMethods = (): UsePaymentMethodsReturn => {
    const {
        state,
        loadPaymentMethods,
        addPaymentMethod,
        deletePaymentMethod,
        setDefaultPaymentMethod,
        getDefaultPaymentMethod,
        clearError
    } = usePayment();

    return {
        paymentMethods: state.paymentMethods,
        loading: state.loading,
        error: state.error,
        stripeInitialized: state.stripeInitialized,
        refreshPaymentMethods: loadPaymentMethods,
        addPaymentMethod,
        deletePaymentMethod,
        setDefaultPaymentMethod,
        getDefaultPaymentMethod,
        clearError
    };
};